export const apiUrl = import.meta.env.VITE_APIURL;
